@@ -0,0 +1,208 @@
<template>
  <div>
    <div style="display: flex;">
      <v-btn
        color="#ed1c06"
        :loading="loadingScgExpress || scgExpressOrder.loading"
        depressed
        dark
        @click.stop="dialogTypeShipping = true"
        style="display: inline-block; margin-right: -5px; border-radius: 20px 0px 0px 0px !important;"
      >
        <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_scg') }}
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="grey"
            v-on="on"
            class="ml-0"
            style="display: inline-block; border-radius: 0 ;background-color: #ed1c06 !important;
                          color: white !important;
                          border-color: darkgray;
                          border-radius: 0px 20px 20px 0px !important"
            outline
            icon
          >
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="shipWithScgExpress('printLabel')">
            <v-list-tile-title>{{ $t('print_label') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <v-dialog style="z-index: 210" v-model="dialogTypeShipping" persistent width="500">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <v-layout wrap>
            <v-flex xs6><h2>{{ $t('choose_mode_of_transportation') }}</h2> </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn flat fab small @click="dialogTypeShipping = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout></v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithScgExpress('pick_up')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >local_shipping</v-icon
                      >

                      Pick up</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-hover>
                <v-card
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  @click="shipWithScgExpress('drop_off')"
                  :color="hover ? 'primary' : ''"
                  :dark="hover ? true : false"
                  class="pa-2 ma-2"
                  style="cursor: pointer;"
                >
                  <v-card-text>
                    <span style="font-size: 16px; font-weight: bold;">
                      <v-icon
                        style="font-size: 33px; vertical-align: middle; color: black"
                        class="mr-1"
                        >inventory</v-icon
                      >
                      Drop off</span
                    >
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog style="z-index: 210" v-model="loadingScgExpress" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอสักครู่
          <v-progress-linear
            color="#FFFFFF"
            style="border-radius: 5px;"
            class="text-xs-center"
            v-model="scgExpressLoad"
            height="19"
          >
            <strong style="font-size: 14px; color: #FFF;">{{ scgExpressLoad }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'cbAll'],
  data: function() {
    return {
      summary: this.value,
      scgExpressOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      scgExpressLoad: 0,
      loadingScgExpress: false,
      dialogTypeShipping: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },

  methods: {
    async printMobileLabel(selected) {
      const vm = this
      vm.scgExpressOrder.loading = true
      const response = await this.post(
        `scg-express/${this.selectedBot.pageid}/print-mobile-label`,
        {
          order_ids: selected
        },
        { responseType: 'blob' }
      )
      if (response) {
        const blob = new Blob([response], { type: 'application/pdf' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = 'file.pdf'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
        vm.scgExpressOrder.loading = false
      }
    },
    async shipWithScgExpress(type) {
      const vm = this
      const status = type === 'printLabel' ? ['shipped'] : ['paid']
      let selected = vm.summary.filter(el => {
        return vm.cbAll.includes(el.id) && status.includes(el.status) && el.shippop_status == null
      })
      let notPass = []
      selected.map(item => {
        let address = item.nameaddress ? item.nameaddress.split(' , ') : null
        if (address.includes('')) {
          notPass.push(item.id)
        }
      })
      if (notPass.length > 0) {
        vm.$swal({
          title: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${notPass}`,
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        selected = selected.map(item => item.id)
        if (selected.length == 0) {
          await vm.$swal({
            title: vm.$t('send_with_scg_paid_only'),
            type: 'warning',
            confirmButtonText: vm.$t('Confirm')
          })
        } else {
          if (type == 'printLabel') {
            vm.printMobileLabel(selected)
          } else {
            vm.createOrderScgExpress(selected, type)
          }
        }
      }
    },
    async createOrderScgExpress(selected, type) {
      const vm = this
      try {
        vm.scgExpressLoad = 0
        vm.loadingScgExpress = true
        const response = await vm.post(`scg-express/${vm.selectedBot.pageid}/place-order`, {
          order_ids: selected,
          type: type
        })
        if (response.success) {
          await vm.checkScgExpressCreateOrder(selected)
          vm.scgExpressOrder.show = true

          vm.scgExpressOrder.status = 'PENDING'
          vm.scgExpressOrder.interval = setInterval(async () => {
            let responseCreateOrder = await vm.checkScgExpressCreateOrder(selected)
            if (vm.scgExpressOrder.status == 'SUCCESS') {
              vm.loadingScgExpress = false
              vm.dialogTypeShipping = false
              if (vm.scgExpressOrder.interval) clearInterval(vm.scgExpressOrder.interval)
              await vm.$swal.fire({
                title: vm.$t('Success'),
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              vm.$emit('onRefresh')
            } else if (vm.scgExpressOrder.status == 'FAILED') {
              let dataFailed = ''
              responseCreateOrder.order_data_failed.map(item => {
                if (item.status === 'FAILED') {
                  try {
                    dataFailed += `${item.orderid} เนื่องจาก: ${
                      JSON.parse(item.response_data_json).message
                    } <br/>`
                  } catch (error) {
                    console.log(error)
                  }
                }
              })

              vm.loadingScgExpress = false
              if (vm.scgExpressOrder.interval) clearInterval(vm.scgExpressOrder.interval)

              await vm.$swal.fire({
                title: vm.$t('Error'),
                html: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${dataFailed}`,
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
            }
          }, 5000)
        }
      } catch (error) {
        if (error.response && error.response.data.message == 'INVALID_SHOP_ADDRESS') {
          const result = await vm.$swal.fire({
            title: vm.$t('กรุณาตั้งค่าที่อยู่ผู้ส่ง ก่อนทำการส่งกับ SCG Express'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
          if (result.value) {
            vm.$router.push('/' + vm.currentLang + `/template?tab=ShippingMethod`).catch(() => {})
          }
        } else if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await vm.$swal.fire({
            title: vm.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await vm.$swal.fire({
            title: vm.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        vm.loadingScgExpress = false
      }
    },
    async checkScgExpressCreateOrder(selected) {
      const vm = this
      try {
        let response = await vm.post(`scg-express/${vm.selectedBot.pageid}/verify-place-order`, {
          order_ids: selected
        })
        if (response.success) {
          let data = response.result
          vm.scgExpressLoad = parseInt(
            ((data.total_success + data.total_failed) / data.total_order) * 100
          )
          let isPending = data.order_data_pending.some(i => i.status.includes('PENDING'))
          if (isPending) {
            vm.scgExpressOrder.status = 'PENDING'
          } else {
            let isFailed = data.order_data_failed.some(i => i.status.includes('FAILED'))
            if (isFailed) {
              vm.scgExpressOrder.status = 'FAILED'
            } else {
              vm.scgExpressOrder.status = 'SUCCESS'
            }
          }
        }
        return response.result
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingScg.vue